import { ButtonTextLarge, ButtonTextMedium, ButtonTextSmall } from '../../typographies';
export var ButtonWidthSize;
(function (ButtonWidthSize) {
    ButtonWidthSize["Large"] = "48px";
    ButtonWidthSize["Medium"] = "40px";
    ButtonWidthSize["Small"] = "32px";
})(ButtonWidthSize || (ButtonWidthSize = {}));
export var ButtonBorderRadius;
(function (ButtonBorderRadius) {
    ButtonBorderRadius["Large"] = "24px";
    ButtonBorderRadius["Medium"] = "20px";
    ButtonBorderRadius["Small"] = "16px";
})(ButtonBorderRadius || (ButtonBorderRadius = {}));
export const ButtonFontFoundation = {
    Large: ButtonTextLarge,
    Medium: ButtonTextMedium,
    Small: ButtonTextSmall,
};
export var FontButtonSize;
(function (FontButtonSize) {
    FontButtonSize["Large"] = "16px";
    FontButtonSize["Medium"] = "14px";
    FontButtonSize["Small"] = "12px";
})(FontButtonSize || (FontButtonSize = {}));
export var IconButtonSize;
(function (IconButtonSize) {
    IconButtonSize["Large"] = "24px";
    IconButtonSize["Medium"] = "18px";
    IconButtonSize["Small"] = "16px";
})(IconButtonSize || (IconButtonSize = {}));
export var ButtonSizeEnum;
(function (ButtonSizeEnum) {
    ButtonSizeEnum["unset"] = "unset";
    ButtonSizeEnum["Large"] = "Large";
    ButtonSizeEnum["Medium"] = "Medium";
    ButtonSizeEnum["Small"] = "Small";
})(ButtonSizeEnum || (ButtonSizeEnum = {}));
//# sourceMappingURL=buttonSizeEnum.js.map